<template>
 <AdminPanelShoppingPacket />
</template>

<script>
import AdminPanelShoppingPacket  from '../components/AdminPanelShoppingPacket.vue'
export default {
    data: () => ({}),
    components: {
        AdminPanelShoppingPacket
    },
    methods: {},
    mounted() {}
}
</script>
